import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Action } from "../../components/ActionBar/ActionBar";
import { Header } from "../../components/Header/Header";
import { Title } from "../../components/Title/Title";
import { useAdminUrlInfo } from "../../hooks/useAdminUrlInfo";
import { AdminViewParams, ADMIN_VIEW_PATH } from "../../routes";
import { UserScopeEnum } from "../../schema";
import { buildUrl } from "../../services/buildUrl";
import { EventSettingDetailsProps } from "./EventSettingDetailsView";

export const EventSettingDetailsHeader: React.FC<EventSettingDetailsProps> = ({ eventSetting, ...rest }) => {
  const navigate = useNavigate();
  const { modifier } = useAdminUrlInfo();

  const isEditMode = modifier === "edit";

  const actions: Action[] = useMemo(
    () => [
      isEditMode
        ? {
            label: "Details",
            onClick: () =>
              navigate({
                pathname: buildUrl<AdminViewParams>(ADMIN_VIEW_PATH, {
                  menu: "user-feed",
                  page: "settings",
                  id: eventSetting.id,
                }),
              }),
          }
        : {
            label: "Edit",
            authorizedScopes: [UserScopeEnum.SUPERADMIN, UserScopeEnum.ADMINS, UserScopeEnum.SETTINGS_UPDATE_INFO],
            onClick: () =>
              navigate({
                pathname: buildUrl<AdminViewParams>(ADMIN_VIEW_PATH, {
                  menu: "user-feed",
                  page: "settings",
                  id: eventSetting.id,
                  modifier: "edit",
                }),
              }),
          },
    ],
    [isEditMode, navigate, eventSetting.id],
  );

  const navigation: Action[] = useMemo(() => [], []);

  return (
    <Header actions={actions} navigation={navigation} {...rest}>
      <Title>Event setting</Title>
    </Header>
  );
};
